import { tealiumConfig } from '@/config/tealium.config'

export default {
	install: (app, options = {}) => {
		const profile = tealiumConfig.profile

		// Initialize Tealium data layer
		window.utag_cfg_ovrd = { noview: true }
		window.utag_data = options.initialData || {}

		// Load Tealium script dynamically
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = true
		script.src = `//tags.tiqcdn.com/utag/${tealiumConfig.account}/${profile}/${tealiumConfig.environment}/utag.js`

		script.onerror = () => {
			console.error('Failed to load Tealium script')
		}

		document.head.appendChild(script)

		// Create global tracking methods
		app.config.globalProperties.$tealium = {
			view: (data) => {
				if (window.utag) {
					window.utag.view(data)
				} else {
					console.warn('Tealium not loaded yet')
				}
			},
			link: (data) => {
				if (window.utag) {
					window.utag.link(data)
				} else {
					console.warn('Tealium not loaded yet')
				}
			},
			track: (eventName, data = {}) => {
				if (window.utag) {
					window.utag.link({
						event_name: eventName,
						...data
					})
				} else {
					console.warn('Tealium not loaded yet')
				}
			}
		}

		// Make it available via provide/inject
		app.provide('tealium', app.config.globalProperties.$tealium)
	}
}
